// Quick-start card wording (architecture sprint-04 §6.1 F47). Pure.
import { diffDays, type LocalDate } from '@shared/calendar';
import { formatShortLocalDate } from '@/lib/format';
import type { QuickStartSuggestion } from '@/types/timer';

const NO_PROJECT = 'No project';
const WEEKDAY_WINDOW_DAYS = 6;
const weekdayFormatter = new Intl.DateTimeFormat('en-GB', { weekday: 'long', timeZone: 'UTC' });

export function quickStartLabel(s: Pick<QuickStartSuggestion, 'description' | 'project'>): string {
  return s.description ?? s.project?.name ?? NO_PROJECT;
}

export function quickStartText(s: Pick<QuickStartSuggestion, 'description' | 'project' | 'date'>, today: LocalDate): string {
  const x = quickStartLabel(s);
  const d = diffDays(today, s.date);
  if (d === 1) return `Yesterday you started with ${x} — start again?`;
  if (d >= 2 && d <= WEEKDAY_WINDOW_DAYS) {
    const weekday = weekdayFormatter.format(new Date(`${s.date}T00:00:00Z`));
    return `On ${weekday} you started with ${x} — start again?`;
  }
  return `On ${formatShortLocalDate(s.date)} you started with ${x} — start again?`;
}
